import { render, staticRenderFns } from "./religionReg.vue?vue&type=template&id=1e7b7d5a&scoped=true"
import script from "./religionReg.vue?vue&type=script&lang=js"
export * from "./religionReg.vue?vue&type=script&lang=js"
import style0 from "./religionReg.vue?vue&type=style&index=0&id=1e7b7d5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b7d5a",
  null
  
)

export default component.exports